import {management} from '../../../index'

import {CreateFertilizerUseCase} from './createFertilizerUseCase'
import { DeleteFertilizerByIdUseCase } from './deleteFertilizerByIdUseCase'
import { ShowFertilizerByIdUseCase } from './showFertilizerByIdUseCase'
import { ShowFertilizerUseCase} from './showFertilizerUseCase'
import { UpdateFertilizerByIdUseCase } from './updateFertilizerUseCase'

export const fertilizerService={
  add: new CreateFertilizerUseCase(management),
  show:new ShowFertilizerUseCase(management),
  showFertilizerByIdUseCase:new ShowFertilizerByIdUseCase(management),
  del: new DeleteFertilizerByIdUseCase(management),
  edit: new UpdateFertilizerByIdUseCase(management)
}
